// extracted by mini-css-extract-plugin
export default {"siderbarItems":"SidebarItems_siderbarItems__CMB0D","active":"SidebarItems_active__BQhma"};